import { PromotionFeatures } from '@playq/octopus-common';
import { GenericFailure } from '@playq/services-shared';

import { useEitherQuery, IUseQueryOptionsExtended } from '/api/service-hooks';

import { IPromotionServiceWithBatchQuery, IPromotionsResponse } from './types';

export const queryBulkPromotionsKeys: unknown[] = ['bulk-promotions', 'query'];
export const useQueryBulkPromotions = <ID>(
  ids: ID[] | undefined,
  features: PromotionFeatures[],
  service: IPromotionServiceWithBatchQuery<ID>,
  options?: IUseQueryOptionsExtended<IPromotionsResponse | undefined, GenericFailure | Error>
) =>
  useEitherQuery(
    queryBulkPromotionsKeys.concat(ids, features),
    () => {
      if (ids) {
        return service.queryPromotionsBatch(ids, features);
      }
    },
    {
      enabled: !!ids && ids.length > 0,
      cacheTime: 0,
      ...options,
    }
  );
